import { useEffect, useState } from "react";
import {getMessages} from "../../api/message/messages.api";
import {getDefaultDateRange} from "../../libs/helper";
import {CalendarBar, Dropdown, Pagination, RadioGroup, Table, Tag} from "omoplay";
import moment from "moment/moment";
import GenericBoard from "../form/GenericBoard";
import LoadingBlock from "../LoadingBlock";

const MessageListPage = () => {
  const [page, setPage] = useState(1);
  const [dateRange, setDateRange] = useState(getDefaultDateRange());
  const [type, setType] = useState()
  const [result, setResult] = useState()
  const [tableData, setTableData] = useState([])
  const [totalSize, setTotalSize] = useState(0)
  // 조회 중에는 빈 표 대신 스피너를 보여준다(데이터 없음과 구분되지 않던 문제, 2026-08-05).
  const [loading, setLoading] = useState(true)
  const [loadError, setLoadError] = useState("")

  const messageTypes = [
    {label: "전체", value: ""}, {label: "텍스트 이미지형", value: "FI"},
    {label: "와이드 이미지형", value: "FW"}, {label: "와이드 리스트형", value: "FL"}, {label: "캐러셀 피드형", value: "FC"},
    {label: "알림톡형", value: "AT"}, {label: "알림톡 이미지형", value: "AI"}
  ]

  useEffect(() => {
    const { startDate, endDate } = dateRange;
    setLoading(true)
    setLoadError("")
    getMessages(startDate, endDate, type, result, page - 1, 10, "createdAt,desc").then((res) => {
      if (res.data) {
        setTableData(res.data.map(message => {
          return [
            <div className="flex-center-all h-full font-bold">
              {displayStatus(message.result, message.errorCode)}
            </div>,
            <div className="flex-center-all h-full"><Tag>{message.type}</Tag></div>,
            <div className="flex-align-center h-full"><div className="">{message.content}</div></div>,
            <div className="text-center">{message.sendAt}</div>,
            <div className="flex-center-all h-full">{message.phoneNumber}</div>
          ]
        }))
        setTotalSize(res.data.length === 0 ? 0 : res.data[0].totalSize)
      }
    }).catch((e) => {
      setTableData([])
      setTotalSize(0)
      setLoadError(e?.message || "조회 중 오류가 발생했습니다.")
    }).finally(() => setLoading(false))
  }, [type, result, dateRange, page]);

  const onRadioChecked = (value) => {
    setPage(1)
    setResult(value)
  }
  const onDateInput = (dateRange) => {
    setPage(1)
    setDateRange({
      startDate: moment(dateRange.startDate).format("yyyy-MM-DD"),
      endDate: moment(dateRange.endDate).format("yyyy-MM-DD")
    });
  };

  const onDropdownChanged = (value) => {
    setPage(1)
    setType(value)
  }

  const displayStatus = (status, errorCode) => {
    if (status === "2") {
      return <Tag color="info">발송 성공</Tag>
    } else if (status === "4") {
      return <div className="flex-col text-center"><Tag color="error">발송 실패<br/>({errorCode})</Tag></div>
    } else {
      return <Tag>결과 대기</Tag>;
    }
  };

  const headers = [
    { name: "상태", align: "center", width: "180px" },
    { name: "메시지 타입", align: "center", width: "220px" },
    { name: "발송 내역"},
    { name: "발송 일시", align: "center", width: "150px" },
    { name: "전화번호", align: "center", width: "160px"},
  ];

  const statusItems = [
    { label: "전체", value: "" },
    { label: "발송 성공", value: "2" },
    { label: "발송 실패", value: "4" }
  ]

  return (
    <div className="w-100">
      <div className="flex-col rounded w-full">
        <div className="flex gap-8 bg-white border rounded-lg p-20px mt-[35px] h-[64px]">
          <div className="flex justify-center items-center gap-2">
            <div>발송 일시</div>
            <CalendarBar initDate={{startDate: moment(dateRange.startDate).toDate(), endDate: moment(dateRange.endDate).toDate()}}
                         onConfirm={(props) => onDateInput(props)} />
          </div>
          <div className="flex justify-center items-center gap-2">
            <div>메시지 타입</div>
            <Dropdown variants="default"
                      style={{minWidth: "150px"}}
                      items={messageTypes}
                      onChanged={(items) => onDropdownChanged(items[0].value)}
            />
          </div>
          <div className="flex justify-center items-center gap-2">
            <div>
              <RadioGroup items={statusItems} initChecked={result ?? ""} onSelected={(value) => onRadioChecked(value)} />
            </div>
          </div>
        </div>
        <div style={{marginTop: "30px", marginLeft: "14px"}}>
          <span className="font-16px">
            총 <span className="mainblue-0 font-bold">{totalSize.toLocaleString()}</span>건
          </span>
        </div>
        <div className="flex-col py-4">
          {(loading || loadError) ? (
            <LoadingBlock error={loadError} />
          ) : (
            <>
              <GenericBoard items={tableData} columns={[
                { align: 'left', width: 'w-16' },
                { align: 'left', width: 'w-32' },
                { align: 'left', flex: true },
                { align: 'right', width: 'w-32' },
                { align: 'right' }
              ]} />
              <div className="flex justify-center" style={{marginTop: "24px"}}>
                <Pagination pageSize={10} totalCount={totalSize} currentPage={page} onPaging={(page) => setPage(page)} />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default MessageListPage;
